module.exports = __webpack_public_path__ + "img/icon-pro-4.d0c0e960.png";